// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ugqn","search":"Settings_search__3C5em","filter":"Settings_filter__1r92X"};